<div class="container mx-auto mt-5 px-4">
  <h2 *ngIf="evaluacion" class="text-3xl font-semibold text-center my-5">Evaluación: {{ evaluacion.nombre }}</h2>
  <div class="flex justify-between items-center mb-4">
    <button
      class="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded"
      (click)="volver()"
    >
      Volver
    </button>
  </div>

  <!-- Resultado de la evaluación -->
  <div  *ngIf="resultadoEvaluacion" class="bg-gray-100 p-4 rounded-lg mb-6">
    <h3 class="text-xl font-semibold mb-2">Resultado de la evaluación</h3>
    <p><strong>Calificación:</strong> {{ resultadoEvaluacion.calificacion }}</p>
    <p><strong>Nivel alcanzado:</strong> {{ resultadoEvaluacion.nivel_alcanzado }}</p>
    <p>
      <strong>Fecha de evaluación:</strong>
      {{ resultadoEvaluacion.fecha_evaluacion | date: 'medium' }}
    </p>
  </div>

  <!-- Preguntas y respuestas en 3 columnas -->
  <div class="grid grid-cols-3 gap-4">
    <div *ngFor="let pregunta of preguntasConRespuestas; let i = index" class="mb-6">
      <div class="bg-white p-4 rounded-lg shadow-md">
        <h4 class="text-lg font-semibold mb-2">Pregunta {{ i + 1 }}</h4>
        <ul class="list-disc pl-5">
          <li *ngFor="let alternativa of pregunta.alternativas; let j = index" class="mb-2">
            <span [ngClass]="{
                'font-semibold text-green-600': alternativa.correcta === 1,
                'font-semibold text-red-600': pregunta.respuestaEstudiante?.id_alternativa === alternativa.id_alternativa && alternativa.correcta === 0
              }">
              {{ obtenerLetraAlternativa(j) }} - <!-- Mostrar la letra correspondiente -->
              {{ alternativa.correcta === 1 ? '(Correcta)' : '' }}
              {{ pregunta.respuestaEstudiante?.id_alternativa === alternativa.id_alternativa ? '(Seleccionada)' : '' }}
            </span>
          </li>
        </ul>
        <p class="mt-2">
          <strong>Respuesta del estudiante:</strong>
          {{ pregunta.estadoRespuesta === 'correcta' ? 'Correcta' :
             pregunta.estadoRespuesta === 'incorrecta' ? 'Incorrecta' :
             'No respondida' }}
        </p>
      </div>
    </div>
  </div>
</div>
